module.exports = __webpack_public_path__ + "img/6_157.206d64ae.png";